import * as React from 'react';
import { getUnreadCount, subscribeUnreadCount } from '../services/unreadCountStore';

// Shared unread count for every bell on the page. The first subscriber starts
// the single poller; the last one to unmount stops it.
export const useUnreadCount = (): number => {
  const [unread, setUnread] = React.useState(getUnreadCount);

  React.useEffect(() => {
    const sync = () => setUnread(getUnreadCount());
    const unsubscribe = subscribeUnreadCount(sync);
    // Pick up any change that landed between render and subscribe.
    sync();
    return unsubscribe;
  }, []);

  return unread;
};
